export const getRequiredField = (field) => {
  if (typeof field === "string" && field.trim().length > 0) {
    return `el campo ${field} es requerido.`;
  } else {
    throw new Error("Field must be a non-empty string");
  }
};
